<div class="sign-up-form-container">
  <div class="sign-up-form">
    <div class="sign-up-form-swiper-container">
      <div #formContainer class="sign-up-form-swiper" [formGroup]="form">
        <div
          class="sign-up-form-swiper-item"
          *ngIf="showFirstStep"
          [class.show-step]="(currentStep$ | async) === SIGNUP_PROVIDER_STEP"
        >
          <div class="small-container">
            <app-sign-up-step-one
              [loginURL]="loginURL"
              [nextUrl]="nextUrl"
              [customContent$$]="customContent$$"
              [form]="form"
              [recaptchaV2isEmailInUse]="recaptchaV2isEmailInUse"
              [captchaRef]="captchaRef"
              [recaptchaSiteKey]="recaptchaSiteKey"
              [formFieldEnabled]="formFieldEnabled"
            ></app-sign-up-step-one>
          </div>
        </div>

        <div
          class="sign-up-form-swiper-item"
          [class.show-step]="
            (currentStep$ | async) === ACCOUNT_INFO_STEP_ONE || (currentStep$ | async) === ACCOUNT_INFO_STEP_TWO
          "
        >
          <div class="small-container step-two-container">
            <app-sign-up-step-two-form
              [form]="form"
              [formFieldEnabled]="formFieldEnabled"
              [companyAddressDetails]="companyAddressDetails"
              [countryControl]="countryControl"
              (submitStepTwo)="onSubmitStepTwo()"
            >
            </app-sign-up-step-two-form>
          </div>
        </div>
        <div
          class="sign-up-form-swiper-item"
          [class.show-step]="(currentStep$ | async) === SIGNUP_LOADING_SCREEN"
        >
          <div class="small-container">
            <ng-template [ngTemplateOutlet]="afterSignUpWaiting"></ng-template>
          </div>
        </div>
        <div
          class="sign-up-form-swiper-item"
          [class.show-step]="(currentStep$ | async) === VERIFY_EMAIL_STEP"
        >
          <div class="small-container">
            <ng-template [ngTemplateOutlet]="verifyEmailStep"></ng-template>
          </div>
        </div>
      </div>
      <div class="login-container">
        <span class="login-text">
          {{ 'SIGNUP.ALREADY_HAVE_AN_ACCOUNT' | translate }}
        </span>
        <a data-action="have-an-account-sign-in" class="login-link" [attr.href]="loginURL$ | async">
          {{ 'SIGNUP.SIGN_IN' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="slides[0] as slide">
  <div class="sign-up-info-container" *ngIf="slides?.length"
    [style.background-color]="slide.bgColor"
    [style.background-image]="slide.bgImage ? 'url(' + slide.bgImage + ')' : null"
    [style.background-size]="slide.bgImage ? 'auto' : null"
    [style.background-repeat]="slide.bgImage ? 'no-repeat' : null"
    [style.background-position]="slide.bgImage ? 'left top' : null"
    [style.minWidth.px]="slide.bgImage ? 375 : null"
    [style.minHeight.px]="slide.bgImage ? 240 : null"
  >
    <div class="wp-slide-container" [style.background-color]="slide.bgColor">
      <div class="wp-slide-title" *ngIf="slide.titleHtml" [innerHTML]="slide.titleHtml | iTrustThisHtml"></div>
      <div class="wp-slide-desc" [innerHTML]="slide.descTextHtml | iTrustThisHtml"></div>
      <a
        class="wp-slide-btn"
        *ngIf="slide.primaryButtonLink && slide.primaryButtonText"
        [href]="slide.primaryButtonLink"
      >
        {{ slide.primaryButtonText }}
      </a>
    </div>
  </div>
</ng-container>

<re-captcha
  *ngIf="renderRecaptchaV2"
  #captchaRef="reCaptcha"
  size="invisible"
  (resolved)="$event && resolvedRecaptchaV2($event)"
  [siteKey]="recaptchaSiteKey"
></re-captcha>

<ng-template #afterSignUpWaiting>
  <div class="sign-up-form-explanation sign-up-form-swiper-container">
    <div class="sign-up-form-explanation-title">
      {{ 'SIGNUP.SETUP.AFTER_SIGNUP_WAITING.TITLE' | translate }}
    </div>
    <div class="sign-up-form-explanation-title">
      {{ 'SIGNUP.SETUP.AFTER_SIGNUP_WAITING.TITLE_MORE' | translate }}
    </div>
    <div class="sign-up-form-explanation-subtitle">
      {{ 'SIGNUP.SETUP.AFTER_SIGNUP_WAITING.SUBTITLE' | translate }}
    </div>
    <mat-progress-bar class="sign-up-progress" mode="indeterminate"></mat-progress-bar>
    <img src="../../assets/images/your-logo-here.png" class="your-logo-here" alt="Your Logo Here" />
  </div>
</ng-template>

<ng-template #verifyEmailStep>
  <div class="email-verification-form-explanation sign-up-form-swiper-container">
    <div class="email-verification-form-explanation-title">
      {{ 'SIGNUP.SETUP.VERIFY_EMAIL_STEP.TITLE' | translate }}
    </div>
    <p
      class="email-verification-form-explanation-subtitle"
      [innerHTML]="'SIGNUP.SETUP.VERIFY_EMAIL_STEP.SUBTITLE' | translate: { email: emailSentTo }"
    ></p>
    <p class="email-verification-form-explanation-subtitle">
      {{ 'SIGNUP.SETUP.VERIFY_EMAIL_STEP.FOLLOW_THE_LINK' | translate }}
    </p>
    <div class="email-verification-form-actions">
      <button
        data-action="continue-to-platform"
        class="email-verification-form-button"
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="continuingToPlatform"
        (click)="continueToPlatform()"
        data-testid="continue-to-platform"
      >
        <glxy-button-loading-indicator [isLoading]="continuingToPlatform">
          {{ 'SIGNUP.SETUP.VERIFY_EMAIL_STEP.CONTINUE_TO_PLATFORM' | translate }}
        </glxy-button-loading-indicator>
      </button>
      <ng-template #buttonWithSpinner>
        <button mat-flat-button color="primary" class="email-verification-form-button">
          <span>
            <mat-progress-spinner mode="indeterminate" diameter="26"></mat-progress-spinner>
          </span>
        </button>
      </ng-template>
      <button
        data-action="resend-verification-email"
        class="email-verification-form-button"
        mat-stroked-button
        type="button"
        (click)="resendVerificationEmail()"
        [disabled]="resendingVerificationEmail"
        data-testid="resend-verification-email"
      >
        <glxy-button-loading-indicator [isLoading]="resendingVerificationEmail">
          {{ 'SIGNUP.SETUP.VERIFY_EMAIL_STEP.RESEND_BUTTON_TEXT' | translate }}
        </glxy-button-loading-indicator>
      </button>
      <ng-template #buttonWithSpinner>
        <button mat-flat-button color="primary" class="email-verification-form-button">
          <span>
            <mat-progress-spinner mode="indeterminate" diameter="26"></mat-progress-spinner>
          </span>
        </button>
      </ng-template>
    </div>
  </div>
</ng-template>
